import { Injectable } from '@angular/core';

import { Logger, LoggerPayload } from '@app/core/logging/logger';

@Injectable()
export class ConsoleLogger implements Logger {

    public log(title: string, payload?: LoggerPayload): void {
        console.log(title, this.normalizePayload(payload));
    }

    public debug(title: string, payload?: LoggerPayload): void {
        console.debug(title, this.normalizePayload(payload));
    }

    public info(title: string, payload?: LoggerPayload): void {
        console.info(title, this.normalizePayload(payload));
    }

    public warn(title: string, payload?: LoggerPayload): void {
        console.warn(title, this.normalizePayload(payload));
    }

    public error(error: unknown, payload?: LoggerPayload): void {
        console.error(this.toError(error), this.normalizePayload(payload));
    }

    public critical(error: unknown, payload?: LoggerPayload): void {
        console.error('[CRITICAL]', this.toError(error), this.normalizePayload(payload));
    }

    private toError(error: unknown): Error {
        if (error instanceof Error) {
            return error;
        }
        if (typeof error === 'string') {
            return new Error(error);
        }
        try {
            return new Error(JSON.stringify(error));
        } catch {
            return new Error('Unknown error');
        }
    }

    private normalizePayload(payload?: LoggerPayload): { [key: string]: unknown } | undefined {
        if (payload === undefined) {
            return undefined;
        }
        if (typeof payload === 'string') {
            return { payload };
        }
        return payload;
    }
}
